// extracted by mini-css-extract-plugin
export default {"build-layer-view":"BuildLayerView_build-layer-view__9iFWj","main-content":"BuildLayerView_main-content__IVtdk"};